<template lang="pug">
v-theme-provider(theme="dark")
  base-section#info-alt.py-1
    base-page-content
      v-row(justify='center')
        v-col(cols='12', md='5')
          base-info
          //- base-business-contact
        //- v-col.text-center.hidden-sm-and-down(cols='2')
          //- v-divider(vertical='')
        //- v-col(cols='12', md='5')
          //- base-contact-form(subtitle='Drop us a Line')
</template>

<script setup>
import BaseInfo from '~/components/base/Info.vue'
</script>

<script>
export default {
  name: 'SectionBusinessInfo',
}
</script>
